﻿/*global Date, Math, Object, document, jQuery, parseInt, window */
/****************************************
	belay.js (Belay/Draw lines/ropes/paths between two points.)
*****************************************/
(function ($) {
	'use strict';
	$.fn.belay = function (options) {
		var $ropebag = this,
			settings = $.extend({
				'anchor': 'middle',    /* Where to anchor the belay? (middle or top) */
				'ancorOffset': 0,      /* Do you want to offset the anchor? */
				'animate': true,       /* Do we want to animate the belay? (true or false) */
				'callback': null,      /* Function to call after belay. (Optional) */
				'curve': 0.66,          /* The Control Points pull/curve percent. */
				'plane': 'horizontal', /* What plane to belay? (horizontal or vertical) */
				'ropes': 'yes',        /* Do we need ropes? (yes or no) */
				'selectors': null,     /* Represents an id (Source) that matches a set of classes (Target(s)). */
				'stroke': '#777777',   /* The color of the rope. (Pebble 5) */
				'strokeWidth': 2       /* The width of the rope. */
			}, options),
			callback = settings.callback;
		$ropebag.empty();
		/* Make SVG Element */
		function makeSVGElement(tag, attrs) {
			var el = document.createElementNS('http://www.w3.org/2000/svg', tag);
			Object.keys(attrs).forEach(function (attr) {
				if (attrs.hasOwnProperty(attr)) {
					el.setAttribute(attr, attrs[attr]);
				}
			});
			return el;
		}
		/* Animate Path */
		function animatePath(el, dist, duration, starttime, target, timestamp) {
			var timeStamp = timestamp || Date.now(),
				runtime = timeStamp - starttime,
				progress = runtime / duration;
			progress = Math.min(progress, 1);
			el.style.strokeDashoffset = parseInt(dist - (dist * progress));
			if (runtime < duration) {
				window.requestAnimationFrame(function (timestamp) {
					animatePath(el, dist, duration, starttime, target, timestamp);
				});
			} else {
				if (callback) {
					callback(target);
				}
			}
		}
		/* Belay */
		if (settings.ropes === 'yes') {
			var pathGroups =[],
				paths = [],
				ropebagL = $ropebag.offset().left,
				ropebagT = $ropebag.offset().top;
			/* Selectors */
			settings.selectors.forEach(function (selector) {
				/* Source */
				var $source = $('#' + selector);
				if (!$source.length) {
					return;
				}
				var sourceH = $source.outerHeight(),
					sourceW = $source.outerWidth(),
					sourceL = $source.offset().left,
					sourceT = $source.offset().top;
				/* Targets */
				var $targets = $('.' + selector + ':visible');
				if (!$targets.length) {
					return;
				}
				$targets.each(function () {
					/* Target */
					var $target = $(this),
						targetH = $target.outerHeight(),
						targetW = $target.outerWidth(),
						targetL = $target.offset().left,
						targetT = $target.offset().top;
					/* Settings */
					var anchor = settings.anchor,
						plane = settings.plane,
						direction = (plane === 'horizontal') ? (sourceL > targetL) ? 'left' : 'right' : (sourceT > targetT) ? 'up' : 'down',
						strokeOffset = settings.strokeWidth / 2;
					/* Path */
					var movetoX = (sourceL - ropebagL) + ((plane === 'horizontal') ? (direction === 'right') ? sourceW : 0 : ((sourceW / 2) - strokeOffset)),
						movetoY = (sourceT - ropebagT) + ((plane === 'horizontal') ? (anchor === 'top') ? settings.anchorOffset : ((sourceH / 2) - strokeOffset) : (direction === 'up') ? 0 : sourceH),
						linetoX = (targetL - ropebagL) + ((plane === 'horizontal') ? (direction === 'right') ? 0 : targetW : ((targetW / 2) - strokeOffset)),
						linetoY = (targetT - ropebagT) + ((plane === 'horizontal') ? (anchor === 'top') ? settings.anchorOffset : ((targetH / 2) - strokeOffset) : (direction === 'up') ? targetH : 0),
						curve = ((plane === 'horizontal') ? ((direction === 'right') ? targetL - (sourceL + sourceW) : sourceL - (targetL + targetW)) : ((direction === 'up') ? sourceT - (targetT + targetH) : targetT - (sourceT + sourceH))) * settings.curve,
						cpx1 = (plane === 'horizontal') ? (direction === 'right') ? movetoX + curve : movetoX - curve : movetoX,
						cpy1 = (plane === 'vertical') ? (direction === 'up') ? movetoY - curve : movetoY + curve : movetoY,
						cpx2 = (plane === 'horizontal') ? (direction === 'right') ? linetoX - curve : linetoX + curve : linetoX,
						cpy2 = (plane === 'vertical') ? (direction === 'up') ? linetoY + curve : linetoY - curve : linetoY;
					/* SVG Cubic Bézier Curve Example http://blogs.sitepointstatic.com/examples/tech/svg-curves/cubic-curve.html */
					paths.push(['M' + parseInt(movetoX) + ',' + parseInt(movetoY) + ' C' + parseInt(cpx1) + ',' + parseInt(cpy1) + ' ' + parseInt(cpx2) + ',' + parseInt(cpy2) + ' ' + parseInt(linetoX) + ',' + parseInt(linetoY), $target.attr('id')]);
				});
				if (paths.length) {
					pathGroups.push(paths);
				}
			});
			/* Append Ropes (For cross-browser support we make the SVG elements and animate them using JavaScript.) */
			if (pathGroups.length) {
				/* SVG */
				var svg = makeSVGElement('svg', {
					'class': 'svg',
					'focusable': 'false' /* IE 11 https://stackoverflow.com/questions/18646111/disable-onfocus-event-for-svg-element */
				});
				document
					.getElementById($ropebag.attr('id'))
					.appendChild(svg);
				/* Groups */
				pathGroups.forEach(function (pathGroup, i) {
					var group = makeSVGElement('g', {
						'class': 'group group' + i
					});
					svg.appendChild(group);
					/* Paths */
					pathGroup.forEach(function (pathInfo, i) {
						var path = makeSVGElement('path', {
								'class': 'path path' + i + (settings.animate) ? ' pathAnimate' : '',
								'd': pathInfo[0],
								'fill': 'none',
								'stroke': settings.stroke,
								'stroke-width': settings.strokeWidth
							}),
							target = pathInfo[1];
						group.appendChild(path);
						if (settings.animate) {
							var pathLength = path.getTotalLength(),
								starttime;
							path.style.strokeDasharray = pathLength;
							path.style.strokeDashoffset = pathLength;
							window.requestAnimationFrame(function (timestamp) {
								starttime = timestamp || Date.now();
								animatePath(path, pathLength, 200, starttime, target, timestamp);
							});
						} else {
							if (callback) {
								callback(target);
							}
						}
					});
				});
			}
		} else {
			if (callback) {
				callback();
			}
		}
	};
}(jQuery));